var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanding5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 300",
    width: 900,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 300,
    fill: "#bca89f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 114L21.5 112.3C43 110.7 86 107.3 128.8 103.7C171.7 100 214.3 96 257.2 95.2C300 94.3 343 96.7 385.8 96C428.7 95.3 471.3 91.7 514.2 88.8C557 86 600 84 642.8 86.7C685.7 89.3 728.3 96.7 771.2 102.5C814 108.3 857 112.7 878.5 114.8L900 117L900 0L878.5 0C857 0 814 0 771.2 0C728.3 0 685.7 0 642.8 0C600 0 557 0 514.2 0C471.3 0 428.7 0 385.8 0C343 0 300 0 257.2 0C214.3 0 171.7 0 128.8 0C86 0 43 0 21.5 0L0 0Z",
    fill: "#a08679"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 63L21.5 67.8C43 72.7 86 82.3 128.8 84.5C171.7 86.7 214.3 81.3 257.2 76.2C300 71 343 66 385.8 70C428.7 74 471.3 87 514.2 87.7C557 88.3 600 76.7 642.8 75.7C685.7 74.7 728.3 84.3 771.2 88.7C814 93 857 92 878.5 91.5L900 91L900 0L878.5 0C857 0 814 0 771.2 0C728.3 0 685.7 0 642.8 0C600 0 557 0 514.2 0C471.3 0 428.7 0 385.8 0C343 0 300 0 257.2 0C214.3 0 171.7 0 128.8 0C86 0 43 0 21.5 0L0 0Z",
    fill: "#977967"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 53L21.5 53C43 53 86 53 128.8 56.2C171.7 59.3 214.3 65.7 257.2 66.2C300 66.7 343 61.3 385.8 61.3C428.7 61.3 471.3 66.7 514.2 68.2C557 69.7 600 67.3 642.8 68C685.7 68.7 728.3 72.3 771.2 71.8C814 71.3 857 66.7 878.5 64.3L900 62L900 0L878.5 0C857 0 814 0 771.2 0C728.3 0 685.7 0 642.8 0C600 0 557 0 514.2 0C471.3 0 428.7 0 385.8 0C343 0 300 0 257.2 0C214.3 0 171.7 0 128.8 0C86 0 43 0 21.5 0L0 0Z",
    fill: "#8d6c55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 54L21.5 54.2C43 54.3 86 54.7 128.8 55.2C171.7 55.7 214.3 56.3 257.2 56C300 55.7 343 54.3 385.8 49.5C428.7 44.7 471.3 36.3 514.2 34.7C557 33 600 38 642.8 41.5C685.7 45 728.3 47 771.2 46.8C814 46.7 857 44.3 878.5 43.2L900 42L900 0L878.5 0C857 0 814 0 771.2 0C728.3 0 685.7 0 642.8 0C600 0 557 0 514.2 0C471.3 0 428.7 0 385.8 0C343 0 300 0 257.2 0C214.3 0 171.7 0 128.8 0C86 0 43 0 21.5 0L0 0Z",
    fill: "#826043"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20L21.5 19.3C43 18.7 86 17.3 128.8 18.8C171.7 20.3 214.3 24.7 257.2 26.3C300 28 343 27 385.8 27.5C428.7 28 471.3 30 514.2 29.5C557 29 600 26 642.8 25C685.7 24 728.3 25 771.2 26.8C814 28.7 857 31.3 878.5 32.7L900 34L900 0L878.5 0C857 0 814 0 771.2 0C728.3 0 685.7 0 642.8 0C600 0 557 0 514.2 0C471.3 0 428.7 0 385.8 0C343 0 300 0 257.2 0C214.3 0 171.7 0 128.8 0C86 0 43 0 21.5 0L0 0Z",
    fill: "#765432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding5);
export default __webpack_public_path__ + "static/media/landing-5.b9805323a41569afe40611db091e5f2c.svg";
export { ForwardRef as ReactComponent };